// Styles
import VotingCellContainer from "./VotingCell.styles";

type Props = {
    number: string;
    selected: string | number;
    setSelected: (val?: string) => void;
    disabled?: boolean;
    tooltip?: string;
};

export default function VotingCell({
    number,
    selected,
    setSelected,
    disabled = false,
    tooltip,
}: Props) {
    return (
        <VotingCellContainer
            data-cy="voting-cell"
            title={disabled ? tooltip : undefined}
            className={
                (selected &&
                String(selected)?.toUpperCase() === number?.toString()
                    ? "selected score-" + number
                    : "") + (disabled ? " disabled" : " active")
            }
            onClick={() => {
                if (!disabled) {
                    setSelected(
                        selected?.toString() === number ? undefined : number
                    );
                }
            }}
        >
            {number}
        </VotingCellContainer>
    );
}
